// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z_92","comment":"styles_comment__3kOY6"};